export const SELLER_OFFER_STATUS = {
  draft: 'Черновик', // опубликовать можно
  rejected: 'Отклонен', // опубликовать можно
  placing: 'Размещается в учетной системе',
  published: 'Опубликован',
  moderation: 'На модерации',
};

export const SELLER_WAREHOUSES_REQUESTS = {
  moderation: 'На модерации',
  approved: 'Одобрена',
  rejected: 'Отклонена',
};
